// 한국 전화번호 입력 포맷팅·검증 — 로그인/회원가입 등 전화번호 입력 필드 공용.

// 입력값(숫자든 하이픈 섞였든)을 정리해 자동으로 하이픈을 넣어준다("01012345678" → "010-1234-5678").
export function formatPhoneInput(raw: string): string {
  const digits = raw.replace(/[^0-9]/g, "").slice(0, 11);
  if (digits.startsWith("02")) {
    // 서울(02): 2-3-4 또는 2-4-4
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    if (digits.length <= 9) return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
  }
  // 휴대폰(010 등)·그 외 지역번호: 3-3-4 또는 3-4-4
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length <= 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
}

export function phoneDigits(value: string): string {
  return value.replace(/[^0-9]/g, "");
}

const MOBILE_PREFIX = ["010", "011", "016", "017", "018", "019"];

// 완성된 번호인지 검사(칸이 다 채워졌을 때만 에러를 보여주기 위해 길이 조건 포함).
// 형식: 서울(02) 9~10자리, 그 외 지역번호·휴대폰 10~11자리, 모두 0으로 시작.
export function phoneError(digits: string): string | null {
  if (!digits) return null;
  if (!digits.startsWith("0")) return "국내 전화번호는 0으로 시작해야 해요.";
  if (digits.startsWith("02")) {
    if (digits.length < 9) return null; // 입력 중
    if (digits.length > 10) return "서울 지역번호(02)는 9~10자리예요.";
    return null;
  }
  if (digits.length < 9) return null; // 입력 중 — 자릿수 덜 채워졌을 땐 에러 표시 안 함
  if (digits.length > 11) return "전화번호가 너무 깁니다.";
  if (digits.startsWith("01") && !MOBILE_PREFIX.includes(digits.slice(0, 3))) {
    return "올바른 휴대폰 번호 형식이 아니에요(010/011/016~019).";
  }
  return null;
}

export function isValidPhone(digits: string): boolean {
  if (!digits.startsWith("0")) return false;
  const len = digits.length;
  if (digits.startsWith("02")) return len >= 9 && len <= 10;
  return len >= 9 && len <= 11;
}
